import { HomePageV2 } from "../../../ui/pages/v2";

export function HomeV2Route() {
  return <HomePageV2 />;
}
